{
  "roleId": "role-310000-mpers",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-310000",
  "label": "[310000] Statement of profit or loss, by function of expense (MPERS)",
  "taxonomy": "FS-MPERS",
  "sheetId": "StatementOfProfitOrLossByFunction",
  "description": "Statement of profit or loss using classification by function of expense method - MPERS",
  "controls": [
    {
      "qname": "ssmt:DisclosureOnStatementOfProfitOrLossByFunctionAbstract",
      "label": "Statement of Profit or Loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ContinuingOperationsAbstract",
      "label": "Continuing operations",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Revenue",
      "label": "Revenue",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-smes:Revenue"
        }
      }
    },
    {
      "qname": "ifrs-smes:CostOfSales",
      "label": "(-) Cost of sales",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-smes:CostOfSales"
        }
      }
    },
    {
      "qname": "ifrs-smes:GrossProfit",
      "label": "Gross profit",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:OtherIncome",
      "label": "Other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-smes:OtherIncome"
        }
      }
    },
    {
      "qname": "ssmt-mpers:SellingAndDistributionExpenses",
      "label": "(-) Selling and distribution expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:AdministrativeExpense",
      "label": "(-) Administrative expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:ResearchAndDevelopmentExpense",
      "label": "(-) Research and development expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:OtherExpenseByFunction",
      "label": "(-) Other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-smes:OtherExpenseByFunction"
        }
      }
    },
    {
      "qname": "ssmt-mpers:ProfitLossFromOperatingActivities",
      "label": "Profit (loss) from operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-smes:FinanceIncome",
      "label": "Finance income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-smes:FinanceIncome"
        }
      }
    },
    {
      "qname": "ifrs-smes:FinanceCosts",
      "label": "(-) Finance costs",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:ShareOfProfitLossOfAssociatesAndJointVenturesAccountedForUsingEquityMethod",
      "label": "Share of profit (loss) of associates and joint ventures accounted for using equity method",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossBeforeTax",
      "required": true,
      "label": "Profit (loss) before tax",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-smes:ProfitLossBeforeTax"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:IncomeTaxExpenseContinuingOperations",
      "label": "(-) Tax expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:ContributionOfZakat",
      "label": "(-) Contribution to zakat",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossFromContinuingOperations",
      "required": true,
      "label": "Profit (loss) from continuing operations, net",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ssmt-mpers:DiscontinuedOperationsAbstract",
      "label": "Discontinued operations",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossFromDiscontinuedOperations",
      "label": "Profit (loss) from discontinued operations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-smes:ProfitLossFromDiscontinuedOperations"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:ProfitLoss",
      "required": true,
      "label": "Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "410000",
          "qname": "ifrs-smes:ProfitLoss"
        }
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-smes:ProfitLoss_2"
          },
          {
            "sheet": "statementOfChangesInEquity",
            "field": "ifrs-smes:ProfitLoss"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossAttributableToAbstract",
      "label": "Profit (loss), attributable to",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossAttributableToOwnersOfParent",
      "label": "Profit (loss), attributable to owners of parent",
      "type": "MonetaryItemType",
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Profit (loss), attributable to owners of parent\" MUST be reported."
      },
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mpers:ProfitLossAttributableToOtherComponentsOfEquity",
      "label": "Profit (loss), attributable to equity other components",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:ProfitLossAttributableToNoncontrollingInterests",
      "label": "Profit (loss), attributable to non-controlling interests",
      "type": "MonetaryItemType",
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Profit (loss), attributable to non-controlling interests\" MUST be reported."
      },
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-smes:ProfitLoss_2",
      "required": true,
      "label": "Total Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "410000",
          "qname": "ifrs-smes:ProfitLoss"
        }
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-smes:ProfitLoss"
          }
        ]
      }
    }
  ]
}
